import React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { Input } from '@progress/kendo-react-inputs';

export const NumberFilter: React.FC<GridFilterCellProps> = (props) => {
    const handleChange = (e: any) => {
        props.onChange({
          value: !!e.target.value ? e.target.value : null,
            operator: 'contains',
            syntheticEvent: e
        });
    };

    return (
        <div className="k-filtercell">
            <Input
                type='number'
                value={props.value || ''}
                onChange={handleChange} />
        </div>
    );
};
